import DescriptionView from "/components/modules/theater-details/DescriptionView";
import AdditionalMaterialView from "/components/modules/theater-details/AdditionalMaterialView";
import ViewHeader from "/components/shared/ViewHeader";
import {useRouter} from "next/router";
import RoomLayout from "/components/shared/layouts/RoomLayout";
import RoomBox from "/components/shared/layouts/RoomBox";
import {THEATERDETAILS_NAVIGATION as items} from '/components/shared/constants';
import EventContext from '/context/EventContext.js';
import MobileViewHeader from "/components/modules/theater-details/MobileViewHeader";
import LeftNav from "/components/modules/theater-details/LeftNav";
import SchoolsView from "/components/modules/theater-details/SchoolsView";
import NextShowsView from "/components/modules/theater-details/NextShowsView";
import DetailsView from "/components/modules/theater-details/DetailsView";
import {fetchProductionBySlug, fetchProductions} from '/api/productions';
import {useCallback} from "react";
import {handleScroll} from "/utils";
import GallerieView from "/components/modules/theater-details/GallerieView";

function ViewsContainer({production}) {
    const router = useRouter();
    const {nav, slug} = router.query;
    const scroll = 'scrollbar-thin overflow-x-hidden scrollbar-thumb-gold overflow-y-scroll scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-track-gray-light';

    console.log()
    const handleScrollEvent = useCallback((e) => {
        handleScroll(e)
    }, [])

    return (
        <RoomLayout key="room" background="bg-cover bg-roomImage">
            <RoomBox style='mt-24 md:px-8 md:py-4'>
                <ViewHeader title="Alle Stücke" url="/productions"/>
                <EventContext.Provider value={{event: production}}>
                    <div className="parent md:py-3 px-2 flex flex-col md:flex-row h-full overflow-hidden">
                        <div className='navChild hidden md:block border-r-[1px] border-blue-medium md:mr-12'>
                            <LeftNav items={items} production={production} id='my_div'/>
                        </div>
                        <div className='md:hidden'>
                            <MobileViewHeader/>
                        </div>
                        <div
                            id='scroll-container'
                            className={`w-full flex-1 p-4 md:px-0 md:pr-12 ${scroll}`}
                            onScroll={handleScrollEvent}
                        >
                            <GallerieView id="gallerie" classIdentifier='child'/>
                            <DetailsView id="details" classIdentifier='child'/>
                            <DescriptionView id="description" classIdentifier='child'/>
                            <NextShowsView id="tickets" classIdentifier='child'/>
                            <SchoolsView id="for-schools" classIdentifier='child'/>
                            <AdditionalMaterialView id="additional-material" classIdentifier='child'/>
                        </div>
                    </div>
                </EventContext.Provider>
            </RoomBox>
        </RoomLayout>
    );
}


export default function TheaterDetails(
    {
        children, production
    }
) {
    return <ViewsContainer production={production}>{children}</ViewsContainer>;
}


export async function getStaticPaths() {
    const productions = await fetchProductions();
    const paths = productions.map(production => ({params: {slug: production.slug}}));

    return {
        paths,
        fallback: 'blocking'
    };
}


export async function getStaticProps(context) {
    const production = await fetchProductionBySlug(context.params.slug);

    return {
        props: {
            production
        },
        revalidate: 60
    };
}
